module.exports = __webpack_public_path__ + "img/street-view.a19e8d2e.svg";